"use strict";
import React from "react";
import _ from "underscore";
import classNames from "classnames";
import Account from "../../api/account";
var index = 0;
function auditFlag(code, label, hasCustomMessage = false) {
  index += 1;
  return { code, label, hasCustomMessage, index };
}
const DEFAULT_AUDIT_FLAGS = [
  auditFlag("no_flags", "No Flags"),
  auditFlag("broker_fa", "Broker FA"),
  auditFlag("automatic_denial", "Automatic Denial"),
  auditFlag("client_invoice", "Client Invoice"),
  auditFlag("3rd_party_carrier", `3rd Party ${Account.carrierTerm()} on BOL`),
  auditFlag("missing_bol", "Missing Bill of Lading/Drop"),
  auditFlag("missing_pod", "Missing POD"),
  auditFlag("missing_rate", "Missing Rate Sheet"),
  auditFlag("missing_receipts", "Missing Receipts"),
  auditFlag("carrier_name", `${Account.carrierTerm()} Name on Rate Sheet`),
  auditFlag("generic_bol", "Generic Bill of Lading"),
  auditFlag("invoice_age", "Invoice Age > 14 Days"),
  auditFlag("invoice_gt_5000", "Invoice Amt > $5,000"),
  auditFlag("extra_rate_sheet", "Extra Rate Sheet/BOL"),
  auditFlag("lumper", "Lumper"),
  auditFlag("bad_quality", "Bad Quality Copies"),
  auditFlag("damage", "Damage/Shortage", true),
  auditFlag("early_late", "Early/Late Delivery", true),
  auditFlag("other_1", "OTHER PROBLEM", true),
  auditFlag("other_2", "OTHER PROBLEM", true)
];
function flagStateFor(flags) {
  const customMessages = {};
  _.each(flags, (f) => {
    customMessages[f.code] = f.customMessage;
  });
  return {
    customMessages,
    flags: flags || []
  };
}
function isChecked(code, flagState) {
  return !!_.findWhere(flagState.flags, { code });
}
function save(props, flagState) {
  props.onFlagUpdate(_.sortBy(flagState.flags, _.property("index")));
}
function flagToggled(props, flag) {
  const flagState = flagStateFor(props.flags);
  if (isChecked(flag.code, flagState)) {
    flagState.flags = _.reject(flagState.flags, function(f) {
      return f.code === flag.code;
    });
    delete flagState.customMessages[flag.code];
  } else {
    flagState.flags.push({
      code: flag.code,
      label: flag.label,
      index: flag.index,
      customMessage: flagState.customMessages[flag.code]
    });
  }
  save(props, flagState);
}
function inputUpdated(props, flag, event) {
  const flagState = flagStateFor(props.flags);
  const value = event.target.value;
  flagState.customMessages[flag.code] = value;
  const existing = _.findWhere(flagState.flags, { code: flag.code });
  if (existing) {
    existing.customMessage = value;
  } else {
    if (value) {
      flagState.flags.push({
        code: flag.code,
        index: flag.index,
        label: flag.label,
        customMessage: value
      });
    }
  }
  save(props, flagState);
}
function clientType(props) {
  return props.transportationClient === false ? "other" : "transportation";
}
function auditFlags(props) {
  const isFlagForType = (flag) => {
    return flag.clientType === "both" || flag.clientType === clientType(props);
  };
  const overriddenFlagsForType = _.select(
    props.overriddenFlags || [],
    isFlagForType
  );
  if (_.isEmpty(overriddenFlagsForType)) {
    return DEFAULT_AUDIT_FLAGS;
  } else {
    return overriddenFlagsForType;
  }
}
function showFlag(props, flag, flagState) {
  if (flag.hasCustomMessage) {
    const labelClasses = classNames({
      column: true,
      "small-3": true
    });
    const flagClasses = classNames({
      column: true,
      "small-7": true,
      end: true
    });
    if (flag.options) {
      return /* @__PURE__ */ React.createElement("li", { key: flag.code }, /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: labelClasses }, flagLabel(props, flag, flagState)), /* @__PURE__ */ React.createElement("div", { className: flagClasses }, /* @__PURE__ */ React.createElement(
        "select",
        {
          onChange: (event) => inputUpdated(props, flag, event),
          value: flagState.customMessages[flag.code]
        },
        /* @__PURE__ */ React.createElement("option", null),
        flag.options.map((t, i) => /* @__PURE__ */ React.createElement("option", { key: i, value: t }, t))
      ))));
    } else {
      return /* @__PURE__ */ React.createElement("li", { key: flag.code }, /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: labelClasses }, flagLabel(props, flag, flagState)), /* @__PURE__ */ React.createElement("div", { className: flagClasses }, /* @__PURE__ */ React.createElement(
        "input",
        {
          onChange: (event) => inputUpdated(props, flag, event),
          value: flagState.customMessages[flag.code],
          type: "text"
        }
      ))));
    }
  } else {
    return /* @__PURE__ */ React.createElement("li", { key: flag.code }, flagLabel(props, flag, flagState));
  }
}
function flagLabel(props, flag, flagState) {
  return /* @__PURE__ */ React.createElement("label", null, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      checked: isChecked(flag.code, flagState),
      onChange: () => flagToggled(props, flag)
    }
  ), " ", flag.label);
}
function AuditFlagEditor(props) {
  const flagState = flagStateFor(props.flags);
  const [custom, noCustom] = _.partition(
    auditFlags(props),
    (flag) => flag.hasCustomMessage
  );
  const scale = !props.compact ? 1 : 2;
  const column_setting = Account.currentSettings().factor_audit_flag_columns || 2;
  const columns = scale * column_setting;
  const customColumns = scale;
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      "data-component": "AuditFlagEditor",
      className: "factor-invoice__audit-flags"
    },
    /* @__PURE__ */ React.createElement("ul", { className: "small-block-grid-" + columns }, noCustom.map((flag) => showFlag(props, flag, flagState))),
    /* @__PURE__ */ React.createElement("ul", { className: "small-block-grid-" + customColumns }, custom.map((flag) => showFlag(props, flag, flagState)))
  );
}
export default AuditFlagEditor;
